/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import App from 'apmui/App';
import bind from '../../decorators/bind';
import { IMessageBoxModel, FORM_ID } from './Model';
import RichText from 'apmui/components/markup/RichTextView';

const app = App.get();

export default class MessageBoxView extends React.Component<IMessageBoxModel> {
    @bind
    linkClick() {
        app.submitForm(FORM_ID);
    }
    render() {
        const config = this.props.messageBox.config;
        return (
            <div className="apmui-content">
                <h2>{config.title}</h2>
                {config.message && (
                    <p>
                        <RichText text={config.message} />
                    </p>
                )}
                <button className="apmui-button apmui-button-submit" id="continue" onClick={this.linkClick}>
                    {config.proceedMessage}
                </button>
            </div>
        );
    }
}
